import React, { useEffect, useState, useRef } from 'react'
import { POSITION_TABLE, ROUTES, ACTION, PAGE_SIZE_OPTIONS, IMAGE_DEFAULT } from 'consts'
import { useHistory, Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { compare } from 'utils'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

//componenets
import FilterDate from 'components/filter-date'
import FilterRegion from 'components/filter-region'

//antd
import {
  Row,
  Button,
  Space,
  Input,
  Table,
  Popconfirm,
  notification,
  Switch,
  Col,
  Select,
} from 'antd'

//icons
import { DeleteOutlined, SearchOutlined } from '@ant-design/icons'

//apis
import { getMenus, deleteMenu, updateMenu } from 'apis/menu'
import { getCountries } from 'apis/country'

export default function Menus() {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const typingTimeoutRef = useRef(null)

  const [menus, setMenus] = useState([])
  const [countMenu, setCountMenu] = useState(0)
  const [loading, setLoading] = useState(false)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })
  const [valueSearch, setValueSearch] = useState('')

  const _onSearch = (e) => {
    setValueSearch(e.target.value)

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      const value = e.target.value

      if (value) paramsFilter.name = value
      else delete paramsFilter.name

      paramsFilter.page = 1
      setParamsFilter({ ...paramsFilter })
    }, 750)
  }

  const _deleteMenu = async (menu_id) => {
    try {
      setLoading(true)
      const res = await deleteMenu([menu_id])
      setLoading(false)
      console.log(res)
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Xóa thực đơn thành công' })
          _getMenus()
        } else
          notification.error({
            message: res.data.message || 'Xóa thực đơn thất bại, vui lòng thử lại',
          })
      } else
        notification.error({
          message: res.data.message || 'Xóa thực đơn thất bại, vui lòng thử lại',
        })
    } catch (error) {
      setLoading(false)
    }
  }

  const _onClearFilters = () => {
    setValueSearch('')
    setParamsFilter({ page: 1, page_size: 20 })
  }

  const _getMenus = async () => {
    try {
      setLoading(true)
      const res = await getMenus({ ...paramsFilter })
      console.log(res)
      if (res.status === 200) {
        setMenus(res.data.data)
        setCountMenu(res.data.count)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const _updateMenu = async (body, record) => {
    try {
      setLoading(true)
      const res = await updateMenu(record.menu_id, body)
      setLoading(false)
      if (res.status === 200) {
        if (res.data.success) {
          _getMenus()
          notification.success({ message: 'Cập nhật thực đơn thành công' })
        } else
          notification.error({
            message: res.data.message || 'Cập nhật thực đơn thành công, vui lòng thử lại',
          })
      } else
        notification.error({
          message: res.data.message || 'Cập nhật thực đơn thành công, vui lòng thử lại',
        })
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const columnsParent = [
    {
      title: 'STT',
      align: 'center',
      render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
    },
    {
      title: 'Tên thực đơn',
      align: 'center',
      sorter: (a, b) => compare(a, b, 'name'),
      render: (text, record) => (
        <Link to={{ pathname: ROUTES.MENU_UPDATE, state: record }}>{record.name || ''}</Link>
      ),
    },
    {
      title: 'Mã thực đơn',
      align: 'center',
      dataIndex: 'code',
      sorter: (a, b) => compare(a, b, 'code'),
    },
    {
      title: t('common.create_date'),
      align: 'center',
      sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
      render: (text, record) =>
        record.create_date && moment(record.create_date).format('DD/MM/YYYY HH:mm:ss'),
    },
    {
      title: 'Quốc gia',
      align: 'center',
      render: (text, record) =>
        record.country_infos && record.country_infos.map((country) => country.name).join(', '),
    },
    {
      title: 'Khu vực',
      align: 'center',
      render: (text, record) =>
        record.region_infos && record.region_infos.map((region) => region.name).join(', '),
    },
    {
      title: 'Chi nhánh',
      align: 'center',
      render: (text, record) =>
        record.branch_infos && record.branch_infos.map((branch) => branch.name).join(', '),
    },
    {
      title: t('common.priority'),
      align: 'center',
      dataIndex: 'priority',
      sorter: (a, b) => compare(a, b, 'priority'),
    },
    {
      title: 'Delivery',
      align: 'center',
      render: (text, record) => (
        <Switch
          checked={record.is_delivery}
          onChange={(checked) => _updateMenu({ is_delivery: checked }, record)}
        />
      ),
    },
    {
      title: t('category_item.open_for_sale'),
      align: 'center',
      render: (text, record) => (
        <Switch
          checked={record.is_active}
          onChange={(checked) => _updateMenu({ is_active: checked }, record)}
        />
      ),
    },
    {
      title: 'Gourmet',
      align: 'center',
      render: (text, record) =>(
        <Switch
        checked={record.is_gourmet}
        onChange={(checked) =>_updateMenu({ is_gourmet: checked }, record)}
        />
      ),
    },
    {
      width: 100,
      title: t('common.action'),
      align: 'center',
      render: (text, record) => (
        <Space size="middle">
          <Popconfirm
            onConfirm={() => _deleteMenu(record.menu_id)}
            title="Bạn có muốn xóa thực đơn này không?"
          >
            <DeleteOutlined style={{ color: 'red', fontSize: 18, cursor: 'pointer' }} />
          </Popconfirm>
        </Space>
      ),
    },
  ]

  useEffect(() => {
    _getMenus()
  }, [paramsFilter])

  return (
    <div className="card-container">
      <Row
        align="middle"
        justify="space-between"
        style={{ borderBottom: '0.75px solid #BBBCBD', paddingBottom: 15 }}
      >
        <h3 style={{ marginBottom: 0, fontWeight: 700, marginRight: 7 }}>Quản lý thực đơn</h3>
        <Button size="large" type="primary" onClick={() => history.push(ROUTES.MENU_CREATE)}>
          Tạo thực đơn
        </Button>
      </Row>
      <Row gutter={[16, 16]} style={{ marginTop: 10, marginBottom: 10 }}>
        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
          <Input
            allowClear
            value={valueSearch}
            onChange={_onSearch}
            prefix={<SearchOutlined />}
            placeholder="Tìm kiếm theo tên thực đơn"
            size="large"
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
          <FilterDate size="large" paramsFilter={paramsFilter} setParamsFilter={setParamsFilter} />
        </Col>
        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
          <FilterRegion
            width_size={'100%'}
            setParamsFilter={setParamsFilter}
            paramsFilter={paramsFilter}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={2} xl={2}>
          <Button
            onClick={_onClearFilters}
            type="primary"
            danger
            style={{ display: Object.keys(paramsFilter).length <= 2 && 'none' }}
            size="large"
          >
            {t('common.clear_filter')}
          </Button>
        </Col>
      </Row>

      <Table
        pagination={{
          position: POSITION_TABLE,
          current: paramsFilter.page,
          pageSize: paramsFilter.page_size,
          pageSizeOptions: PAGE_SIZE_OPTIONS,
          showQuickJumper: true,
          onChange: (page, pageSize) => setParamsFilter({ page: page, page_size: pageSize }),
          total: countMenu,
        }}
        rowKey="category_id"
        loading={loading}
        dataSource={menus}
        columns={columnsParent}
        style={{ width: '100%' }}
        size="small"
      />
    </div>
  )
}
